import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

interface Currency {
    code: string;
    name: string;
    gender: string;
    rate: number;
    defaultCurrency: boolean;
    site: boolean;
}

interface Currencies {
    default: Currency | null;
    list: Array<Currency>;
}

export default autoGeneratedReducer<Currencies>({
    default: null,
    list: [],
});
